import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store/store';
import { verify } from '../../../store/slices/auth';
import styles from './ForgotPasswordOtp.module.scss';

import Input from '../../../components/UI/Inputs/Input';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../hooks/useTranslations';

function ForgotPasswordOtp() {
  const [otp, setOtp] = useState('');
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state.email;

  const handleSubmit = async () => {
    await dispatch(verify({ username: email, verification_code: otp }));
    const error = localStorage.getItem('verify-error');
    if (error === '401') {
      navigate('/web/forget/set-new-password');
    } else {
      toast.error('Something went wrong.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.emailConfirmationContent}>
        <div className={styles.checkEmailPhoto} />
        <div className={styles.title}>{translations('label.check_your_email')}</div>
        <div className={styles.verificationCode}>
          {translations('label.we_sent_a_code')} <b>{email}</b>
        </div>

        <div className={styles.otpInput}>
          <div className={styles.verificationCode}>
            {translations('label.please_enter_your_verification_code')}
          </div>
          <div className={styles.otpInput}>
            <Input
              placeholder={translations('label.otp_code')}
              label={translations('label.otp_code')}
              value={otp}
              onChange={(e: any) => setOtp(e.target.value)}
              type={'text'}
              id={'otp'}
              isSecure={false}
              textarea={false}
              errorText={''}
            />
          </div>
        </div>
        <PrimaryButtonV2
          text={translations('action.confirm')}
          containerStyle={{
            width: '100%',
          }}
          buttonStyle={{
            width: '100%',
          }}
          disabled={email === ''}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}

export default ForgotPasswordOtp;
